/**
 * Default: Vendors
 */

import VendorsCookieConsent from './cookie-consent';
import VendorsFancybox      from './fancybox';

const index = () => {
	/* eslint-disable no-console */
	// if (processEnv === 'development') {
	// 	console.log('Vendors');
	// }
	/* eslint-enable no-console */

	VendorsCookieConsent();
	VendorsFancybox();
};

export default index;
